import { isVerticalAppRoute } from '@common/urlBasePath';
import { Entity } from '@prophecy/shared-core/entity';
import { isCaseInsensitiveEqual } from '@prophecy/utils/string';

export * from '@prophecy/shared-core/entity';

export const getPipelineEntityName = (name: Entity) => {
  const isVerticalApp = isVerticalAppRoute();
  return isCaseInsensitiveEqual(name, Entity.Pipeline) && isVerticalApp ? Entity.Pipeline : name;
};

export const getAppEntityName = (name: Entity) =>
  isCaseInsensitiveEqual(name, Entity.App) ? 'Analysis' : getPipelineEntityName(name);
